<template>
    <section class="emsculpt-feedback py-5 overflow-hidden">
        <div class="container">
            <h1 class="text-center display-4 font-noto-serif-tc mb-5"
                data-aos="flip-up"
                data-aos-duration="1000">
                用家分享
            </h1>

            <h3 class="font-weight-bold text-center mb-3">
                女性
            </h3>
            <div class="feedbacks mb-4">
                <div class="position-relative feedback-group mb-3">
                    <div class="position-absolute btn-swiper-wrapper left d-flex align-items-center">
                        <button class="btn-swiper text-white display-4 h1"
                                v-on:click="slidePrev('swiperFemaleWaistInstance')">
                            <font-awesome-icon icon="caret-left"></font-awesome-icon>
                        </button>
                    </div>

                    <swiper ref="swiperFemaleWaist"
                            v-bind:options="swiperOptions">
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/monique.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Monique
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                媽媽
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                腰腹
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        即使產後常做收腹運動，仍未能解決「腹直肌分離」問題。Emsculpt療程可收窄腹直肌分離及腹白線，令腹肌變得有力，腰背痛也得到改善。
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/milk.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Milk
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                媽媽
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                腰腹
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        「腹直肌分離」引致「媽媽肚」鬆弛突出，令人困擾。Emsculpt的專利HIFEM緊磁波能夠深入肌肉7cm，幫我緊緻肚皮外觀，回復平坦結實的小腹。
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/dada.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Dada
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                美食博客
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                腰腹
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        因工作關係常吃美食，肚腩積聚不少脂肪！做完一次Emsculpt後已感到整個人挺直了，腹部結實了，腰圍也幼了，增肌減脂效果非常Work！
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/anssica.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Anssica
                                            </h3>
                                            <h6 class="text-secondary font-weight-normal mb-0">
                                                美妝達人
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                腰腹
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        Emsculpt有效刺激肌肉收縮，30分鐘等於大半日高強度運動，還可塑造馬甲線！不但省時，亦毫無疲累感和酸痛感，適合忙碌的都市女性！
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                    </swiper>

                    <div class="position-absolute btn-swiper-wrapper right d-flex align-items-center">
                        <button class="btn-swiper text-white display-4 h1"
                                v-on:click="slideNext('swiperFemaleWaistInstance')">
                            <font-awesome-icon icon="caret-right"></font-awesome-icon>
                        </button>
                    </div>
                </div>

                <div class="position-relative feedback-group">
                    <div class="position-absolute d-flex align-items-center d-lg-none btn-swiper-wrapper left">
                        <button class="btn-swiper text-white display-4 h1"
                                v-on:click="slidePrev('swiperFemaleOthersInstance')">
                            <font-awesome-icon icon="caret-left"></font-awesome-icon>
                        </button>
                    </div>

                    <swiper ref="swiperFemaleOthers"
                            v-bind:options="swiperOptions">
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/cyndi.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Cyndi
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                模特兒
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                臀部
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        做深蹲辛苦又成效慢，EmSculpt不出汗不會累，30分鐘即可訓練臀部肌肉2萬次，有效提升集中臀部，改善鬆弛及方形Pat ，輕鬆擁有蜜桃臀！
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/kiko.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Kiko
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                模特兒、媽媽
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                手臂
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        懷孕時長時間沒有運動，一雙麒麟臂令自信心下降。Emsculpt可以減薄拜拜肉的脂肪層，強化手臂肌肉，鍛鍊出緊緻結實的手臂！
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                    </swiper>

                    <div class="position-absolute d-flex align-items-center d-lg-none btn-swiper-wrapper right">
                        <button class="btn-swiper text-white display-4 h1"
                                v-on:click="slideNext('swiperFemaleOthersInstance')">
                            <font-awesome-icon icon="caret-right"></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </div>

            <h3 class="font-weight-bold text-center mb-3">
                男性
            </h3>
            <div class="feedbacks mb-4">
                <div class="position-relative feedback-group">
                    <div class="position-absolute d-flex align-items-center d-lg-none btn-swiper-wrapper left">
                        <button class="btn-swiper text-white display-4 h1"
                                v-on:click="slidePrev('swiperMale')">
                            <font-awesome-icon icon="caret-left"></font-awesome-icon>
                        </button>
                    </div>

                    <swiper ref="swiperMale"
                            v-bind:options="swiperOptions">
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/kong_lam.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Kong Lam
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                舞蹈教師
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                腰腹
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        30分鐘已等於2萬次Sit-up的運動量，全程不出汗亦無拉傷風險，不會影響我的舞蹈工作！比做Gym更舒適更快見效，推薦給想鍛鍊腹肌的男士！
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                        <swiper-slide class="h-auto">
                            <feedback-card class="h-100">
                                <template v-slot:avatar>
                                    <img class="rounded-lg h-100 w-100"
                                         v-bind:alt="``"
                                         src="../../../assets/campaign/emsculpt-v2/feedback/ken_to.jpg">
                                </template>
                                <template v-slot:default>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h3 class="text-feedback font-weight-bold mb-0">
                                                Ken To
                                            </h3>
                                            <h6 class="text-dark font-weight-normal mb-0">
                                                藝人
                                            </h6>
                                        </div>
                                        <div>
                                            <h3 class="text-feedback mb-0">
                                                腰腹
                                            </h3>
                                        </div>
                                    </div>

                                    <p class="text-dark text-justify">
                                        療程後已看到腹肌線條逐漸浮現，腹肌雖然高頻收縮達2萬次，但過程只會感受到肌肉收緊提升，簡單舒適，療程後亦無需休息，很方便！
                                    </p>
                                </template>
                            </feedback-card>
                        </swiper-slide>
                    </swiper>

                    <div class="position-absolute d-flex align-items-center d-lg-none btn-swiper-wrapper right">
                        <button class="btn-swiper text-white display-4 h1"
                                v-on:click="slideNext('swiperMale')">
                            <font-awesome-icon icon="caret-right"></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import "swiper/css/swiper.min.css";
    import {
        Swiper,
        SwiperSlide,
    } from "vue-awesome-swiper";
    import FeedbackCard from "./FeedbackCard";

    export default {
        name: "EmsculptFeedback",
        components: {
            FeedbackCard,
            Swiper,
            SwiperSlide,
        },
        data () {
            return {
                "swiperOptions": {
                    "loop": true,
                    "effect": "slide",
                    "slidesPerView": 1,
                    "spaceBetween": 0,
                    "breakpoints": {
                        "960": {
                            "slidesPerView": 2,
                        }
                    },
                },
            };
        },
        computed: {
            swiperFemaleWaistInstance () {
                if (this.$refs.swiperFemaleWaist) {
                    return this.$refs.swiperFemaleWaist.$swiper;
                }
                return {};
            },

            swiperFemaleOthersInstance () {
                if (this.$refs.swiperFemaleOthers) {
                    return this.$refs.swiperFemaleOthers.$swiper;
                }
                return {};
            },

            swiperMale () {
                if (this.$refs.swiperMale) {
                    return this.$refs.swiperMale.$swiper;
                }
                return {};
            },
        },
        methods: {
            slidePrev (swiper) {
                this[swiper].slidePrev();
            },

            slideNext (swiper) {
                this[swiper].slideNext();
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/variables";
    @import "~bootstrap/scss/mixins/_breakpoints";
    @import "./variables.scss";

    .emsculpt-feedback {
        background-color: $background-color;
        color: $text-color;

        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1425.51884 808.29504'%3E%3Cg id='pear_filled'%3E%3Cpath d='M1073.64152,561.18893s.8832-12.97737,10.89758-8.07417-7.2761,3.14247-7.2761,3.14247Z' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3Cpath d='M1039.16654,638.60249a28.44993,28.44993,0,0,1-14.3303-47.04855c6.01973-6.4845,14.789-9.9011,20.77721-16.41472,2.89-3.14371,5.03522-6.91019,7.90843-10.06937s6.82281-5.77742,11.08515-5.51642c0,0,10.92306-.23853,16.41974,8.03935a16.75112,16.75112,0,0,1,2.44081,12.139c-.73334,4.2069-2.39283,8.21119-3.10364,12.42188-1.47262,8.72453,1.20655,17.74645-.22375,26.478a28.44993,28.44993,0,0,1-45.95089,17.53394' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3C/g%3E%3Cg id='pear_outline'%3E%3Cpath d='M538.03574,209.26437s-7.03326-10.94191,3.929-12.98125S538,203.14591,538,203.14591Z' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3Cpath d='M556.55139,291.95992a28.44992,28.44992,0,0,1-39.56915-29.20968c.96259-8.79541,5.96209-16.769,6.882-25.569.44391-4.24713-.08147-8.54971.33971-12.79922s2.029-8.707,5.60541-11.04043c0,0,8.624-6.70794,17.97382-3.34373a16.75106,16.75106,0,0,1,9.20077,8.286c1.92122,3.81374,2.97828,8.01742,4.91985,11.82077,4.02305,7.88042,11.55554,13.52264,15.61675,21.38345a28.44993,28.44993,0,0,1-26.41751,41.4854' transform='translate(-246.13399 -99.312)' fill='none' stroke='%23ecbb8f' stroke-miterlimit='10' stroke-width='3'/%3E%3C/g%3E%3Cg id='pear_outline-2' data-name='pear_outline'%3E%3Cpath d='M1352.45673,107.40889s6.32548-11.36575,13.29844-2.66477-7.92159-.25521-7.92159-.25521Z' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3Cpath d='M1288.29763,162.77128a28.44992,28.44992,0,0,1,7.06948-48.67181c8.208-3.30367,17.59735-2.66064,25.78927-6.00407,3.95361-1.61371,7.49852-4.10808,11.44351-5.74294s8.63355-2.32192,12.379-.27066c0,0,9.98471,4.43572,11.433,14.26626a16.75106,16.75106,0,0,1-2.9609,12.02267c-2.455,3.49409-5.66172,6.41047-8.098,9.91759-5.04773,7.2668-6.46559,16.57071-11.478,23.8619a28.44992,28.44992,0,0,1-49.04292-3.7034' transform='translate(-246.13399 -99.312)' fill='none' stroke='%23ecbb8f' stroke-miterlimit='10' stroke-width='3'/%3E%3C/g%3E%3Cg id='pear_filled-2' data-name='pear_filled'%3E%3Cpath d='M256.16946,826.0332s-9.45078-8.93728.70315-13.54456-2.2043,7.613-2.2043,7.613Z' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3Cpath d='M293.96557,901.88066a28.44992,28.44992,0,0,1-45.41669-18.87452c-1.17351-8.76977,1.76919-17.7092.55318-26.47318-.587-4.22973-2.12827-8.281-2.73786-12.50759s-.11707-8.93955,2.7959-12.06211c0,0,6.76492-8.57939,16.64852-7.55416a16.75106,16.75106,0,0,1,10.91854,5.83927c2.77929,3.24211,4.81307,7.06991,7.60961,10.29706,5.79454,6.6865,14.45979,10.35891,20.28667,17.01723A28.44992,28.44992,0,0,1,288.919,904.17052' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3C/g%3E%3Cg id='pear_outline-3' data-name='pear_outline'%3E%3Cpath d='M1613.38675,699.94747s-9.68514-8.68274.34264-13.55847-2.001,7.66894-2.001,7.66894Z' transform='translate(-246.13399 -99.312)' fill='%23ecbb8f'/%3E%3Cpath d='M1653.18693,774.76278a28.44992,28.44992,0,0,1-45.90265-17.65983c-1.40636-8.73545,1.29752-17.75-.15118-26.47853-.69926-4.21262-2.34777-8.22144-3.06957-12.43033s-.3548-8.93328,2.47408-12.13222c0,0,6.53432-8.75629,16.4417-7.99432a16.75111,16.75111,0,0,1,11.07,5.54679c2.86454,3.16705,4.99941,6.93939,7.8808,10.091,5.97034,6.53,14.7302,9.97064,20.73213,16.47162a28.44992,28.44992,0,0,1-14.45921,47.00909' transform='translate(-246.13399 -99.312)' fill='none' stroke='%23ecbb8f' stroke-miterlimit='10' stroke-width='3'/%3E%3C/g%3E%3C/svg%3E%0A");

        .feedbacks {
            & > .feedback-group {
                background-color: $background-color-alt;
                border-radius: 25px;
            }
        }

        .text-feedback {
            color: rgba(241, 161, 1, 1);
        }

        .btn-swiper-wrapper {
            width: 33px;
            height: 100%;

            top: 0;

            &.left {
                left: -20px;
            }

            &.right {
                right: -20px;
            }

            @include media-breakpoint-up(sm) {
                &.left {
                    left: -35px;
                }

                &.right {
                    right: -35px;
                }
            }

            & > .btn-swiper {
                background: none;
                outline: none;
                border: none;

                filter: drop-shadow(0px 0px 5px rgba(0, 0, 0 ,0.25));
                z-index: 9;
            }
        }

        .rounded-lg {
            border-radius: 15px !important;
        }
    }
</style>
